export const GET_RAVEN_TRANSACTION_TYPE_DEF = "GET_RAVEN_TRANSACTION_TYPE_DEF"
export const GET_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS = "GET_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS"
export const GET_RAVEN_TRANSACTION_TYPE_DEF_FAIL = "GET_RAVEN_TRANSACTION_TYPE_DEF_FAIL"

export const ADD_RAVEN_TRANSACTION_TYPE_DEF = "ADD_RAVEN_TRANSACTION_TYPE_DEF"
export const ADD_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS = "ADD_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS"
export const ADD_RAVEN_TRANSACTION_TYPE_DEF_FAIL = "ADD_RAVEN_TRANSACTION_TYPE_DEF_FAIL"

export const UPDATE_RAVEN_TRANSACTION_TYPE_DEF = "UPDATE_RAVEN_TRANSACTION_TYPE_DEF"
export const UPDATE_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS = "UPDATE_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS"
export const UPDATE_RAVEN_TRANSACTION_TYPE_DEF_FAIL = "UPDATE_RAVEN_TRANSACTION_TYPE_DEF_FAIL"

export const DELETE_RAVEN_TRANSACTION_TYPE_DEF = "DELETE_RAVEN_TRANSACTION_TYPE_DEF"
export const DELETE_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS = "DELETE_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS"
export const DELETE_RAVEN_TRANSACTION_TYPE_DEF_FAIL = "DELETE_RAVEN_TRANSACTION_TYPE_DEF_FAIL"

export const RAVEN_TRANSACTION_TYPE_DEF_API_ERROR = "API_ERROR"
